// extracted by mini-css-extract-plugin
export default {"heading":"Bs-z","corrected":"Cs-z","redirectVerbiageContainer":"Ds-z","redirectVerbiageText":"Es-z"};